import { Drawer, Box, Typography } from '@mui/material'
import * as styles from './BlendInstrucions.styled'

interface BlendInstructionsProps {
  open: boolean
  onClose: () => void
}

export const BlendInstructions = ({
  open,
  onClose,
}: BlendInstructionsProps) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={styles.drawer}
      PaperProps={{ sx: styles.drawerPaper }}
    >
      <Box sx={styles.content}>
        <Typography variant="h5" gutterBottom>
          🧪 Blending Module – Help Guide
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          ✅ What does the Blending module do?
        </Typography>
        <ul>
          <li>Optimizes blend selection based on Wheat Code costs.</li>
          <li>
            Ensures all blend specifications (e.g., protein, moisture) are met.
          </li>
          <li>
            Provides clear blend suggestions including composition, parameters,
            and cost.
          </li>
        </ul>

        <Typography variant="subtitle1" gutterBottom>
          📦 Which deliveries are included?
        </Typography>
        <ul>
          <li>Belong to your Site.</li>
          <li>Have an accepted bin assignment.</li>
          <li>
            Linked to a Wheat Code that is “In Use” and has a defined cost.
          </li>
        </ul>
        <Typography variant="body2" gutterBottom>
          ℹ️ Note: Wheat Code cost directly influences blend optimization.
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          ⚙️ Blend Specifications & Limitations
        </Typography>
        <ul>
          <li>Equinom Bin 1 – No more than 30%</li>
          <li>Equinom Bin 2 – No less than 10%</li>
          <li>Equinom Bin 4 – Equals 50%</li>
        </ul>

        <Typography variant="body2" color="warning.main">
          ⚠️ If a bin has no available deliveries, any limitation set for it
          will be ignored.
        </Typography>
      </Box>
    </Drawer>
  )
}
